import { useAgreement } from '.'
import { useUser } from '@cibo/profile'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useAgreementCopy = (agreementId: string) => {
  const { t, i18n } = useTranslation('impact/pages/Agreements/AgreementCopy')
  const agreement = useAgreement(agreementId)
  const user = useUser()

  const agreementCopy = useMemo(() => {
    if (!!agreement.data) {
      // @ts-ignore force this onto the model until refactor
      const { status, agreementType, agreementCopy, userId } = agreement.data
      const values = {
        context: user.data?.isGrower() || user.data?.matchUserId(userId) ? 'self' : 'other',
        agreementName: agreement.data?.fileName || 'other',
      }
      //use the agreement copy or fallback to the i18n string
      return !!agreementCopy?.[agreementType]?.[status]
        ? i18n.services.interpolator.interpolate(
            agreementCopy[agreementType][status],
            values,
            i18n.language,
            {}
          )
        : t(`${status}-${agreementType}Md`, values)
    }
  }, [agreement.isFetched, user.isFetched])
  return agreementCopy
}
